/**
 * Generates a random key to make React happy (shouldn't be used for anything else).
 *
 * @returns string
 */var generateKey = function generateKey() {
  return Math.random().toString(16).slice(2);
};
export { generateKey };